import React, { Component } from 'react';

import API from 'API';

import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class ChimneyDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        };
    }

    componentDidMount() {
        this.load();
    }

    async load() {
        const chimneyTypes = await API.call('book/list-chimney-types');
        this.setState({
            chimneyTypes,
            isLoading: false
        });
    }

    render() {
        const { isLoading, chimneyTypes, isBusy } = this.state;
        const { bookingRequest, onBackClicked, onChimneyTypeSelected, index } = this.props;

        if (isLoading) {
            return (<Loader />);
        }

        return (<>

            <h2>What kind of chimney do you have?</h2>

            <div className="btn-stack">

                {chimneyTypes.map(ct =>
                    <button
                        key={ct.id}
                        type="button"
                        className={`btn btn-secondary selection-btn ${ct.id == bookingRequest.chimneyTypeIDs[index] ? 'selected' : ''    }`}
                        onClick={() => onChimneyTypeSelected(ct.id)}
                        disabled={isBusy}
                    >
                        <div className="selection-btn-name">
                            {ct.name}
                        </div>
                        <div className="selection-btn-description">
                            {ct.description}
                        </div>
                    </button>
                )}

                <button
                    type="button"
                    className="btn btn-secondary selection-btn"
                    onClick={() => onChimneyTypeSelected(null)}
                    disabled={isBusy}
                >
                    <div className="selection-btn-name">
                        I Don't Know / Other
                    </div>
                    <div className="selection-btn-description">
                        Don't know what type of chimney you've got, or not listed here? Don't worry.
                    </div>
                </button>

            </div>
            
            <div className="nav-buttons">

                <button type="button" className="btn btn-secondary me-auto" onClick={() => onBackClicked()} disabled={isBusy}>
                    Back
                </button>

            </div>

        </>);
    }

}

export default ChimneyDetails;